<template>
    <ui-Ubication
        :icon="getImage($img[location.type])"
        :locationName="location.name || $dicc.locations.default"
        :location="weather.city"
        :weatherLoaded="weather.description ? true : false"
        :weather="weather.description"
        :temperature="weather.temperature_now"
        :min="weather.temperature_min"
        :max="weather.temperature_max"
        :actionLabel="$dicc.locations.addInstallation"
        @addInstallation="$emit('addInstallation', location.id)"
        @click="$emit('click')"
    >
        <template v-slot:installations>
            <ui-Ico
                v-for="char in location.chars"
                :key="char"
                :valueIco="$class.installation[char]"
            ></ui-Ico>
        </template>
    </ui-Ubication>
</template>

<script>
    export default {
        name: 'Location',
        props: {
            location: Object,
        },
        data: function() {
            return { weather: {} };
        },
        mounted() {
            this.$onInstance('refresh', () => {
                this.init(
                    () => this.$emitInstance('startRefresh'),
                    () => this.$emitInstance('endRefresh')
                );
            });
            this.init();
        },
        methods: {
            init(callbackStart, callbackEND) {
                if (this.location.country) this.getWeather(callbackStart, callbackEND);
            },
            getWeather(callbackStart, callbackEND) {
                if (callbackStart) callbackStart();
                if (this.$config.ENV != 'local')
                    this.$api.getWeather(this.location.id, (data) => (this.weather = data.entity), null, callbackEND);
                else {
                    this.weather = {
                        city: 'San Sebastián',
                        description: 'soleado',
                        temperature_now: 24.26,
                        temperature_min: 22.67,
                        temperature_max: 26.61,
                    };
                    if (callbackEND) callbackEND();
                }
            },
            // getImage: function () {
            //     var images = require.context("../assets/", false, /\.png$/);
            //     return images(`./${this.location.type}.png`);
            // },
        },
        watch: {
            'device.status.tc': function(val) {
                this.txtMsg = val;
            },
        },
    };
</script>
